import { CommonModule }    from '@angular/common';
import { NgModule }        from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';

import { VideoViewerComponent } from './video-viewer.component';
import { VideoViewerService }   from './video-viewer.service';

@NgModule({
  declarations: [
    VideoViewerComponent
  ],
  entryComponents: [
    VideoViewerComponent
  ],
  exports: [
    VideoViewerComponent
  ],
  imports: [
    CommonModule,
    TranslateModule
  ],
  providers: [
    VideoViewerService
  ]
})
export class VideoViewerModule {}
